import {getElement} from "./utils/getElement";

const initDocSearch = () => {
    const searchForm = getElement('#ajax-search-form');
    if (!searchForm) {
        return null;
    }

    searchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var searchQuery = document.getElementById('search').value;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', wpstatsHelper.ajax_url + '?action=ajax_search&search=' + encodeURIComponent(searchQuery), true);

        xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 400) {
                document.getElementById('search-results').innerHTML = xhr.responseText;
                document.getElementById('search-results').classList.add('is-open')
            } else {
                console.error('Error: ' + xhr.status);
            }
        };

        xhr.onerror = function() {
            console.error('Request failed');
        };

        xhr.send();
    });


    document.addEventListener('click', function (e) {
        if (!e.target.closest('.c-search__form')) {
            document.getElementById('search-results').classList.remove('is-open')
        }
    })
}

export {initDocSearch}
